"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateResult = void 0;
var axios_1 = __importDefault(require("axios"));
var mobx_1 = require("mobx");
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var ValidateResult;
(function (ValidateResult) {
    ValidateResult[ValidateResult["VALID"] = 0] = "VALID";
    ValidateResult[ValidateResult["INVALID"] = 1] = "INVALID";
})(ValidateResult = exports.ValidateResult || (exports.ValidateResult = {}));
// eslint-disable-next-line @typescript-eslint/ban-types
var ReviewStoreBase = /** @class */ (function () {
    function ReviewStoreBase() {
        var _this = this;
        this.rate = 0;
        this.content = "";
        this.nickname = "";
        this.email = "";
        this.userInputMapName = "";
        this.updateNickname = false;
        this.submitReview = function () {
            var validateResult = _this.validate();
            if (validateResult.result === ValidateResult.VALID) {
                dialog_store_1.default.showDialog({
                    title: "送信中...",
                    description: "しばらくお待ちください",
                    show_time: -1
                });
                axios_1.default
                    .post(_this.submitReviewApiUrl, _this.postReviewParams)
                    .then(function (res) {
                    var data = res.data.data;
                    dialog_store_1.default.hideDialog();
                    dialog_store_1.default.showDialog({
                        title: "投稿が完了しました",
                        description: "承認されると表示されますので、しばらくお待ちください。",
                        btnList: (_this.getIsHistoryBackable && history.length > 1) ? [
                            {
                                title: "続けて投稿する",
                                callback: function () {
                                    _this.handlePostSuccess(data);
                                    dialog_store_1.default.hideDialog();
                                },
                                customClass: "btn-blue"
                            },
                            {
                                title: "元のページに戻る",
                                callback: function () {
                                    history.back();
                                },
                                customClass: "btn-orange"
                            }
                        ] : [
                            {
                                title: "閉じる",
                                callback: function () {
                                    _this.handlePostSuccess(data);
                                    dialog_store_1.default.hideDialog();
                                },
                                customClass: "btn-blue"
                            }
                        ],
                        show_time: -1
                    });
                })
                    .catch(function (_a) {
                    var response = _a.response;
                    var data = response.data;
                    // FIXME: HIKAKAKU-3030
                    dialog_store_1.default.hideDialog();
                    if (data && data.version === 'v1') {
                        dialog_store_1.default.showErrorDialog(data.message, data.details);
                    }
                    else {
                        dialog_store_1.default.showErrorDialog();
                    }
                });
            }
            else {
                dialog_store_1.default.showDialog({
                    title: "入力に不備があります",
                    description: validateResult.errors.join("<br/>"),
                    btnList: [
                        {
                            title: "閉じる",
                            callback: function () {
                                dialog_store_1.default.hideDialog();
                            },
                            customClass: "btn-blue"
                        },
                    ],
                    show_time: -1
                });
            }
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
    ReviewStoreBase.prototype.handlePostSuccess = function (_) { };
    ReviewStoreBase.prototype.validate = function () {
        var errorMessages = this.validators
            .filter(function (_a) {
            var validator = _a.validator;
            return validator() === ValidateResult.INVALID;
        })
            .map(function (_a) {
            var errorMessage = _a.errorMessage;
            return errorMessage;
        });
        return errorMessages.length === 0
            ? { result: ValidateResult.VALID }
            : { result: ValidateResult.INVALID, errors: errorMessages };
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ReviewStoreBase.prototype, "rate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ReviewStoreBase.prototype, "content", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ReviewStoreBase.prototype, "nickname", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ReviewStoreBase.prototype, "email", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ReviewStoreBase.prototype, "userInputMapName", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ReviewStoreBase.prototype, "updateNickname", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ReviewStoreBase.prototype, "submitReview", void 0);
    return ReviewStoreBase;
}());
exports.default = ReviewStoreBase;
